import { render, staticRenderFns } from "./ExtendedForms.vue?vue&type=template&id=24e0b9f7&"
import script from "./ExtendedForms.vue?vue&type=script&lang=js&"
export * from "./ExtendedForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports